import { useLocation, useNavigate } from 'react-router-dom';
import type { AttributeEntityType } from './contracts';
import { createAttributesOverviewPath } from './routeUtils';

export function useCloseAttributeModal(entityType: AttributeEntityType, entityId: string) {
    const location = useLocation();
    const navigate = useNavigate();
    const routeState: unknown = location.state;

    return () => {
        if (
            typeof routeState === 'object' &&
            routeState !== null &&
            'fromAttributesOverview' in routeState &&
            routeState.fromAttributesOverview === true
        ) {
            navigate(-1);
        } else {
            navigate(createAttributesOverviewPath(entityType, entityId), { replace: true });
        }
    };
}
